package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import one.healthium.data.user.utils.toId

@Serializable
internal data class FoodLogDto(
    @SerialName("id") val id: String? = null,
    @SerialName(FIELD_DATE) val date: Timestamp,
    @SerialName("food") val food: List<FoodItemDto>,
) {
    companion object {
        const val FIELD_DATE = "timestamp"
    }
}

@Serializable
internal data class FoodItemDto(
    @SerialName("id") private val _id: String? = null,
    @SerialName("amount") val amount: Float,
    @SerialName("isLiquid") val isLiquid: Boolean? = null,
    @SerialName("name") val name: String,
    @SerialName("timestamp") val date: Timestamp,
    @SerialName("calories") val calories: Float,
    @SerialName("fat") val fat: Float,
    @SerialName("carbohydrates") val carbohydrates: Float,
    @SerialName("fiber") val fiber: Float,
    @SerialName("protein") val protein: Float,
    @SerialName("tablespoon") val tablespoon: Float? = null,
    @SerialName("cups") val cups: Float? = null,
    @SerialName("pieces") val pieces: Float? = null,
    @SerialName("portion") val portion: Float? = null,
    @SerialName("unit") val unit: String? = null,
) {
    @Transient
    val id: String = _id ?: date.toId()
}
